import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class ContactUsList extends React.Component {
  state = {
    Products_data: [],
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
    isloading: false,
  }
  componentDidMount() {
    this.getConstant()
  }

  getConstant = async () => {
    this.setState({
      isloading: true,
      Products_data: [],
    })

    await axios
      .get(Constant.getAPI() + `/user/list-contact-us`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            Products_data: res.data.data,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
            disabled: this.state?.pageNumber + 1 >= res?.data?.pagination?.pages,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isloading: false,
        })
      })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.getConstant()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.getConstant()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'user_email',
        label: 'User Email',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'user_email',
        label: 'User Email',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'country_code',
        label: 'Country Code',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'phone',
        label: 'Phone',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'user_name',
        label: 'User Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'user_message',
        label: 'Message',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'createdAt',
        label: 'Created Date',
        options: {
          filter: true,
          sort: true,
          sortDirection: 'desc',
          customBodyRender: (createdAt) => {
            var date = new Date(createdAt)
            var year,
              month,
              day,
              created_date = ''
            year = date.getFullYear()
            if (date.getMonth() > 8) {
              month = date.getMonth() + 1
            } else {
              month = '0' + (date.getMonth() + 1)
            }
            if (date.getDate() > 9) {
              day = date.getDate() + 1
            } else {
              day = '0' + (date.getDate() + 1)
            }
            created_date = day + ' / ' + month + ' / ' + year
            return <span>{created_date}</span>
          },
        },
      },
      //  {
      //   name: "id",
      //   label: "Action",
      //   options: {
      //     filter: true,
      //     sort: true,
      //     customBodyRender: (id, tableMeta) => {
      //       return (
      //         <Link
      //           to={"/contact-us/add/" + id}
      //           className="m-r-15 text-muted"
      //           data-toggle="tooltip"
      //           data-placement="top"
      //           title=""
      //           data-original-title="Edit"
      //         >
      //           <i className="f-20 icofont icofont-ui-edit text-custom"></i>
      //         </Link>
      //       )
      //     }

      //   }
      // },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      search: true,
      filter: true,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.getConstant()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.getConstant()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isloading ? <Loader open={this.state.isloading} /> : 'Sorry, No Contact Us Request Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Contact Us List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Contact Us List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Contact Us List'}
                          className="table-responsive"
                          data={this.state.Products_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactUsList
